import { useState } from "react";
import { NXDelete, NXEditPen } from "../../../icons";
import useApi from "../../../api";
import { useDeleteConfirmation } from "../../common";
import GenericSelectableTable from "../../selectableTable";
import WarehouseForm from "./WarehouseForm";


function WarehouseTable({ data, refresh }: { data: any, refresh:()=>void }) {
  const api = useApi();
  const { handleDelete } = useDeleteConfirmation();


  const [edit, setEdit] = useState<any>(null)

  const columns = [
    { header: "ID", key: "node.dbId"},
    { header: "Name", key: "node.name", render: (item: any)=> (
      <div className="flex items-center gap-2">
        <p>{item.node.name}
            {item.node.is_default && (
            <span className="bg-blue-100 text-blue-800 text-xs font-semibold mr-2 ml-2 px-2.5 py-0.5 rounded">
              Default
            </span>
            )}
          </p>
      </div>
    )},
    { header: "Location", key: "node.location"},

    { header: "Action", key: "", render: (item: any)=>(
      <div className="flex gap-1 items-center">
        <button
          className="p-1"
          onClick={() => {
            handleDelete(
              item.node.dbId,
              "Tax Class",
              api.deleteWarehouse,
              refresh
            );
          }}
        >
          <NXDelete className="text-red-600" />
        </button>
        <button className="p-1" onClick={(e: any) => setEdit(item)}>
          <NXEditPen />
        </button>
      </div>
    )}
  ]


  

  return (
    <div className="mt-4">
     
        <GenericSelectableTable columns={columns} data={data}/>


      { edit && <WarehouseForm edit={edit} isOpen={edit ? true : false} onClose={()=>setEdit(null)} refresh={refresh}/> }
    </div>
  );
}

export default WarehouseTable;
